import { render, staticRenderFns } from "./teacherProgressReport.vue?vue&type=template&id=8981ecc2&scoped=true"
import script from "./teacherProgressReport.vue?vue&type=script&lang=js"
export * from "./teacherProgressReport.vue?vue&type=script&lang=js"
import style0 from "./teacherProgressReport.vue?vue&type=style&index=0&id=8981ecc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8981ecc2",
  null
  
)

export default component.exports